import PropTypes from 'prop-types';
import BrIcons from '@components/BrIcons';
import ColorStyles from '@components/ColorStyles';

export default function StarColumn({ row, col, cell }) {
  const isStarred = cell.value;
  const onClickHandler = () => col.columnConfig.onClick(row, !isStarred);

  return (
    <div onClick={onClickHandler}>
      {isStarred ? (
        <BrIcons.Star className="star-column-icon" colorStyle={ColorStyles.YELLOW} />
      ) : (
        <BrIcons.HoloStar className="star-column-icon" colorStyle={ColorStyles.GRAY} />
      )}
    </div>
  );
}

StarColumn.propTypes = {
  row: PropTypes.object.isRequired, // row data
  col: PropTypes.shape({
    // column config
    columnConfig: PropTypes.shape({
      onClick: PropTypes.func.isRequired, // (row, value:bool) :=> {}
    }).isRequired,
  }).isRequired,
  cell: PropTypes.shape({
    value: PropTypes.bool,
  }).isRequired,
};
